// 用于管理枚举字段

// 审批状态
export const workFlowStatus = [
  { label: '待提交', value: 0, type: 'primary' },
  { label: '审核中', value: 1, type: 'warning' },
  { label: '已完成', value: 2, type: 'success' },
  { label: '已驳回', value: 3, type: 'danger' },
]

// 单位入厂状态
export const unitStatus = [
  { label: '待入厂', value: 0, type: 'primary' },
  { label: '在厂', value: 1, type: 'success' },
  { label: '已退厂', value: 2, type: 'danger' },
  { label: '黑名单', value: 3, type: 'danger' },
]

// 危险源辨识计划 计划状态
export const planStatus = [
  { label: '待发布', value: 0, type: 'primary' },
  { label: '已发布', value: 1, type: 'warning' },
  { label: '已逾期', value: 2, type: 'danger' },
  { label: '已完成', value: 3, type: 'success' },
]

// 工器具管理-试验状态
export const statusList = [
  { label: '正常', value: 0, type: 'success' },
  { label: '超期未检', value: 1, type: 'danger' },
  { label: '即将到期', value: 2, type: 'warning' },
  { label: '报废', value: 3, type: 'danger' },
]

// 工器具管理-借用状态
export const borrowList = [
  { label: '借用中', value: 0, type: 'primary' },
  { label: '不可借', value: 1, type: 'danger' },
  { label: '可借', value: 2, type: 'success' },
]

// 评估状态计算
export const evaluateStatus = [
  {
    value: 0,
    label: '待评估',
    type: 'primary',
  },
  {
    value: 1,
    displayName: '已评估',
    type: 'success',
  },
  {
    value: 2,
    label: '已逾期',
    type: 'danger',
  },
  {
    value: 3,
    label: '被驳回',
    type: 'danger',
  },
]

// 管控级别对应的风险颜色
export const riskColor = [
  {
    value: '重大风险',
    type: '红色',
  },
  {
    value: '较大风险',
    type: '橙色',
  },
  {
    value: '一般风险',
    type: '黄色',
  },
  {
    value: '低风险',
    type: '蓝色',
  },
]

// 风险等级
export const riskList = [
  {
    label: '重大风险',
    value: 0,
  },
  {
    label: '较大风险',
    value: 1,
  },
  {
    label: '一般风险',
    value: 2,
  },
  {
    label: '低风险',
    value: 3,
  },
]

// 风险等级
export const lslList = [
  {
    label: '企业经常发生此类事故过5分',
    value: 5,
  },
  {
    label: '企业管控措施不足预期发生4分',
    value: 4,
  },
  {
    label: '行业内有发生过此类事故3分',
    value: 3,
  },
  {
    label: '偶尔发生此类事故2分',
    value: 2,
  },
  {
    label: '没有发生过1分',
    value: 1,
  },
]

// 风险等级
export const lsLevel = [
  {
    min: 20,
    max: 25,
    deep: 'A/1级',
    level: '重大风险',
    color: '红色',
    value: 0,
  },
  {
    min: 15,
    max: 16,
    deep: 'B/2级',
    level: '较大风险',
    color: '橙色',
    value: 1,
  },
  {
    min: 9,
    max: 12,
    deep: 'C/3级',
    level: '一般风险',
    color: '黄色',
    value: 2,
  },
  {
    min: 4,
    max: 8,
    deep: 'D/4级',
    level: '低风险',
    color: '蓝色',
    value: 3,
  },
  {
    min: 1,
    max: 3,
    deep: 'E/5级',
    level: '低风险',
    color: '蓝色',
    value: 4,
  },
]

// 风险等级
export const lecLevel = [
  {
    max: 2000000,
    min: 320,
    deep: 'A/1级',
    level: '重大风险',
    color: '红色',
    value: 0,
  },
  {
    min: 160,
    max: 320,
    deep: 'B/2级',
    level: '较大风险',
    color: '橙色',
    value: 1,
  },
  {
    min: 70,
    max: 160,
    deep: 'C/3级',
    level: '一般风险',
    color: '黄色',
    value: 2,
  },
  {
    min: 20,
    max: 70,
    deep: 'D/4级',
    level: '低风险',
    color: '蓝色',
    value: 3,
  },
  {
    min: 0,
    max: 20,
    deep: 'E/5级',
    level: '低风险',
    color: '蓝色',
    value: 4,
  },
]

// 风险等级
export const lssList = [
  {
    label: '人员死亡损失百万以上5分',
    value: 5,
  },
  {
    label: '丧失劳动力损失50万以上4分',
    value: 4,
  },
  {
    label: '轻伤或慢性疾病一万元以上3分',
    value: 3,
  },
  {
    label: '轻微伤一万元以下2分',
    value: 2,
  },
  {
    label: '无伤亡无损失1分',
    value: 1,
  },
]

export const leclList = [
  {
    label: '完全可以预料到会发生10分',
    value: 10,
  },
  {
    label: '相当可能6分',
    value: 6,
  },
  {
    label: '可能，但不经常3分',
    value: 3,
  },
  {
    label: '可能性小，完全意外1分',
    value: 1,
  },
  {
    label: '极不可能0.2分',
    value: 0.2,
  },
  {
    label: '实际不可能0.1分',
    value: 0.1,
  },
]

export const leceList = [
  {
    label: '一日连续暴露10分',
    value: 10,
  },
  {
    label: '每天工作时问内暴露6分',
    value: 6,
  },
  {
    label: '每周一次，或偶然暴露3分',
    value: 3,
  },
  {
    label: '每月一次暴露2分',
    value: 2,
  },
  {
    label: '每年几次暴露1分',
    value: 1,
  },
  {
    label: '非常罕见的暴露0.5分',
    value: 0.5,
  },
]

export const leccList = [
  {
    label: '10人以上死亡造成重大财产损失100分',
    value: 100,
  },
  {
    label: '数人死亡，或造成很大财产损失40分',
    value: 40,
  },
  {
    label: '一人死亡，或造成一定的财产损失15分',
    value: 15,
  },
  {
    label: '严重，重伤，致残，或较小的财产损失7分',
    value: 7,
  },
  {
    label: '轻伤或很小的财产损失3分',
    value: 3,
  },
  {
    label: '无伤亡，不利于基本的安全卫生要求1分',
    value: 1,
  },
]


export const wordsList = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
